module.exports = __webpack_public_path__ + "img/清华.a9579d81.png";